<template>
  <div class="truncate">
    <a
      :title="presentation.name"
      class="truncate text-link"
    >
      <span
        class="text-base-60"
        v-if="!isSharedPresentation"
      >
        {{ folderName }}
      </span>
      <span>{{ presentation.name }}</span>

    </a>
    <span class="presentation-info">
      <span class="min-w-max">
        <aha-icon-container>
          <aha-icon
            name="slides"
            width="10"
            height="10"
            viewBox="0 0 12 12"
            v-tooltip="$i18nPresenter.t('Number of slides')"
          />
        </aha-icon-container>
        <span class="text-xs text-base-80">
          {{ presentation.slideCount }}
        </span>
      </span>

      <span
        class="ml-4 min-w-max"
        @click.stop="() => {}"
      >
        <aha-icon-container v-tooltip="getParticipantCountTooltip(presentation)">
          <aha-icon
            @click="redirectToReportPage"
            name="people"
            width="12"
            height="12"
            viewBox="0 0 24 24"
          />
        </aha-icon-container>
        <span class="text-xs text-base-80 " @click="redirectToReportPage">
          <aha-formatter
            :value="presentation.participantsCount || presentation.onlineCount"
            type="number"
          />

        </span>
      </span>
      <div
        v-if="isShowParticipantName && showInfo"

        class="hidden lg:flex ml-4 lg:ml-2 audience-name-random  cursor-pointer"
        @click="redirectToReportPage"
      >
        <div class="flex">

          (<div class="truncate-block">{{ participantName }} </div> {{ isShowThreeDot ?"...":"" }})
        </div>

      </div>
      <div class="block-action flex-row-reverse">
        <ReportButton
          v-if="!isDisableReportButton && allowRedirectToReportPage"
          class="report-btn  ml-4 lg:ml-2"
          :presentation="presentation"
        />
        <Reactions
          v-if="showInfo"
          class="reaction-count hidden ml-4 lg:ml-2 lg:inline-block"
          @click.stop="showPresentationReportAction({presentation, trigger: 'reactions'})"
          :presentation="presentation"
        />

        <span
          class="avg-rating hidden lg:flex ml-4 lg:ml-2 presentation-rating flex-row items-center"
          @click.stop="showPresentationReportAction({presentation,trigger: 'rating'})"
          v-if="presentation.avgRating > 0 && showInfo"
        >
          <AhaStarRatingView
            v-tooltip="getRatingTooltip(presentation)"
            class="flex items-center flex-shrink-0"
            :rate="presentation.avgRating"
            size="12px"
          />
          <span class="text-xs text-base-80 mt-0.5 ml-0.5">{{ presentation.avgRating.toFixed(1) }}</span>
        </span>

      </div>
    </span>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import constants from '@/constant'

import Reactions from '@/components-v2/my-presentations/main-table/Reactions.vue'
import ReportButton from './ReportButton.vue'
import { getRatingTooltip } from '@/vuex/modules/presentation/presentation-report.module'
import { ROUTE_NAMES } from '@/constant/routes'

const { workspace } = constants

export default {
  components: {
    Reactions,
    ReportButton,
  },
  props: {
    presentation: {
      type: Object,
      required: true,
    },
    isSharedPresentation: {
      type: Boolean,
      required: true,
    },
    folderName: {
      type: String,
      default: '',
    },
    allowRedirectToReportPage: {
      type: Boolean,
      default: true,
    },
    showInfo: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    isDisableReportButton() {
      if (this.$store.state.isEnableAddinPowerpoint) return true
      if (this.$store.state.currentUser
        && this.$store.state.workingMode === workspace.TEAM
        && this.$store.state.currentUser.accountRole
        && this.$store.state.currentUser.accountRole
        === workspace.VIEWER) return true
      return false
    },
    participantName() {
      let listName = ''
      this.presentation.randomAudience.forEach((audience, index) => {
        listName += audience.name
        if (index < this.presentation.randomAudience.length - 1) {
          listName += ', '
        }
      })
      return listName
    },
    isShowParticipantName() {
      return this.presentation.randomAudience && this.presentation.randomAudience.length > 0
    },
    isLongName() {
      return this.participantName.length > 30
    },
    isShowThreeDot() {
      return this.presentation && this.presentation.participantsCount > 3 || this.isLongName
    },
  },
  methods: {
    ...mapActions('presentationReport', ['selectPresentationAction', 'generateReportAction', 'subscribeReportAction', 'openReportPanelAction', 'showPresentationReportAction']),
    getParticipantCountTooltip(presentation) {
      let tooltip
      if (presentation.participantsCount === null) {
        tooltip = this.$i18nPresenter.t('Largest live audience')
      } else {
        tooltip = `${this.$i18nPresenter.t('Total participants:')} <b>${presentation.participantsCount || 0}</b>. ${this.$i18nPresenter.t('Largest live audience')}: <b>${presentation.onlineCount}</b>.`
      }
      return {
        content: tooltip,
      }
    },
    redirectToReportPage() {
      if (!this.allowRedirectToReportPage) return
      this.$router.push({ name: ROUTE_NAMES.PRESENTATION_REPORT, params: { id: this.presentation.id } })
    },
    getRatingTooltip,

  },

}
</script>

<style lang="scss" scoped>
.presentation-info {
  @apply flex  items-center mt-1  font-normal leading-6 overflow-hidden max-h-6;
}
.block-action{
  @apply flex  items-center  flex-wrap  overflow-hidden max-h-6 ;
  justify-content: left;
}
.audience-name-random{
  color :#707070;
  font-size: 12px;
  font-weight: 400;
}
.truncate-block{
  @apply max-h-6;
  max-width: 320px;
  @media (max-width: 1920px) {
    max-width: 320px;
  }
  @media (max-width: 1512px) {
    max-width: 160px;
  }
  @media (max-width: 1280px){
    max-width: 106px;
  }
  overflow: hidden;
  white-space: nowrap;
  text-align: center;
  display: inline-block;
  width: 100%;
}
</style>
